/**
 * Why a lead was disqualified, stored in `leads.disqualified_reason`. Shared by
 * the lead page's Disqualify button and the /leads Triage tab.
 */
export const DISQUALIFY_REASONS: Array<[value: string, label: string]> = [
    ['wrong_number', 'Wrong number'],
    ['wrong_service', 'Wanted different service (burial / traditional / repat)'],
    ['info_request', 'Information request — not a buyer'],
    ['out_of_service_area', 'Out of service area'],
    ['callback_unanswered', 'Callback unanswered'],
    ['no_engagement_hangup', 'Hang-up / no engagement'],
    ['vendor_pitch', 'Vendor / solicitation'],
    ['not_a_customer', 'Not a customer (job, agency, newspaper)'],
    ['existing_customer', 'Existing customer follow-up'],
    ['other', 'Other'],
];
